import React from "react";
import "./ExpTimeline.css"
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator
} from "@mui/lab"
import CircleIcon from '@mui/icons-material/Circle';

export const ExpTimeline = () => {

  const [width, setWidth] = React.useState(window.innerWidth);
  const breakpoint = 768;
  React.useEffect(() => {
    const handleResizeWindow = () => setWidth(window.innerWidth);
    // subscribe to window resize event "onComponentDidMount"
    window.addEventListener("resize", handleResizeWindow);
    return () => {
      // unsubscribe "onComponentDestroy"
      window.removeEventListener("resize", handleResizeWindow);
    };
  }, []);
  if (width < breakpoint) {
    return (
      <div className="mobileTimeline">
        <div className="singleMobileTimelineItem">
          <h3>10.2020 - 05.2021<br />DSM Intelligence sp. z o.o.<br />(Transcriptionist)</h3>
          <ul>
            <li><CircleIcon className="timelineActivitiesDot" />creating subtitles based on audio/video recordings</li>
          </ul>
        </div>
        <div className="mobileTimelineSeparator">
          <div className="separator"></div>
        </div>
        <div className="singleMobileTimelineItem">
          <h3>01.2023 - 09.2023<br />Stadler Polska Sp. z o.o.<br />(Team Assistant)</h3>
          <ul>
            <li><CircleIcon className="timelineActivitiesDot" />operation of Weidmuller, Texit printers and Komax Zeta machine</li>
            <li><CircleIcon className="timelineActivitiesDot" />printing documentation for rail vehicles according to the company standards</li>
            <li><CircleIcon className="timelineActivitiesDot" />supporting team in usage of computer software and hardware</li>
          </ul>
        </div>
        <div className="mobileTimelineSeparator">
          <div className="separator"></div>
        </div>
        <div className="singleMobileTimelineItem">
          <h3>10.2023 - <span className="pulsatingText">ongoing</span><br />Xpand EuroGroup Sp z o.o. Sp. k.<br />(IT Support/Webmaster/Graphic Designer)</h3>
          <ul>
            <li><CircleIcon className="timelineActivitiesDot" />maintaining existing websites, updating and enhancing them or creating new ones</li>
            <li><CircleIcon className="timelineActivitiesDot" />designing new logos, graphics, business cards, banners etc.</li>
            <li><CircleIcon className="timelineActivitiesDot" />IT and marketing support for company's contractors</li>
            <li><CircleIcon className="timelineActivitiesDot" />supporting and advising the company in terms of IT solutions</li>
            <li><CircleIcon className="timelineActivitiesDot" />occasional repair of computer equipment</li>
          </ul>
        </div>
      </div>
    );
  }

  return (
    <div className="timeline">
      <Timeline className="muiTimelineRule">
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot />
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            <div className="singleTimelineItem">
              <h3>10.2020 - 05.2021 | DSM Intelligence sp. z o.o.<br />(Transcriptionist)</h3>
              <ul>
                <li><CircleIcon className="timelineActivitiesDot" />creating subtitles based on audio/video recordings</li>
              </ul>
            </div>
          </TimelineContent>
        </TimelineItem>
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot />
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            <div className="singleTimelineItem">
              <h3>01.2023 - 09.2023 | Stadler Polska Sp. z o.o.<br />(Team Assistant)</h3>
              <ul>
                <li><CircleIcon className="timelineActivitiesDot" />operation of Weidmuller, Texit printers and Komax Zeta machine</li>
                <li><CircleIcon className="timelineActivitiesDot" />printing documentation for rail vehicles according to the company standards</li>
                <li><CircleIcon className="timelineActivitiesDot" />supporting team in usage of computer software and hardware</li>
              </ul>
            </div>
          </TimelineContent>
        </TimelineItem>
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot color="primary" className="lastJobDot" />
            <TimelineConnector className="lastJobConnector" />
          </TimelineSeparator>
          <TimelineContent>
            <div className="singleTimelineItem">
              <h3>10.2023 - ongoing | Xpand EuroGroup Sp z o.o. Sp. k.<br />(IT Support/Webmaster/Graphic Designer)</h3>
              <ul>
                <li><CircleIcon className="timelineActivitiesDot" />maintaining existing websites, updating and enhancing them or creating new ones</li>
                <li><CircleIcon className="timelineActivitiesDot" />designing new logos, graphics, business cards, banners etc.</li>
                <li><CircleIcon className="timelineActivitiesDot" />IT and marketing support for company's contractors</li>
                <li><CircleIcon className="timelineActivitiesDot" />supporting and advising the company in terms of IT solutions</li>
                <li><CircleIcon className="timelineActivitiesDot" />occasional repair of computer equipment</li>
              </ul>
            </div>
          </TimelineContent>
        </TimelineItem>
      </Timeline>
    </div>
  )
}